import { http } from '../api/http';
import type { Project, Investment } from '../types/Project';

export interface ClientDashboardResponse {
  totalInvested: number;
  activeInvestments: number;
  currentReturnPercent: number;
  featuredProjects: Project[];
  investments?: Investment[];
}

export const DashboardService = {
  getClientDashboard() {
    return http<ClientDashboardResponse>('/dashboard/client');
  }
};
